// filters-toggle
export default function initFiltersToggle() {
	$('.filters-item').each(function(){
		$(this).find('.filters-item__title').on('click', function() {
			$(this).toggleClass('js__open');
			$(this).siblings('.filters-item__cont').slideToggle();
		});
	});

	$('.filter-btn').on('click', function() {
		$('.catalog-filters').addClass('js__open');
		$('body').addClass('filters-open');
	});

	$('.filter-close').on('click', function() {
		$('.catalog-filters').removeClass('js__open');
		$('body').removeClass('filters-open');
	});
}